import dynamic from 'next/dynamic'

export const AuthByAlfaBankAsync = dynamic(
	() => import('./AuthByAlfabank').then(({ AuthByAlfabank }) => AuthByAlfabank),
	{ ssr: false }
)
